import * as Sentry from '@sentry/react';
import { ApolloCache } from '@apollo/client';
import { useMutation } from '@apollo/client/react';
import { API_AKTIVIEREN, API_DEAKTIVIEREN } from '../lib/graphql/mutations';

function schreibeAktivInCache(cache: ApolloCache, neuerWert: boolean) {
  cache.modify({
    fields: {
      aktivierung(existing) {
        return { ...existing, aktiv: neuerWert };
      },
    },
  });
}

export type ApiAktivierung = {
  setzeAktiv: (neuerWert: boolean) => Promise<boolean>;
  loading: boolean;
};

export function useApiAktivierung(): ApiAktivierung {
  const [aktiviere, { loading: aktiviereLaeuft }] = useMutation(
    API_AKTIVIEREN,
    {
      update(cache, { data }) {
        if (data?.aktiviereApi.__typename === 'ApiAktivierenSuccess') {
          schreibeAktivInCache(cache, true);
        }
      },
    },
  );

  const [deaktiviere, { loading: deaktiviereLaeuft }] = useMutation(
    API_DEAKTIVIEREN,
    {
      update(cache, { data }) {
        if (data?.deaktiviereApi.__typename === 'ApiDeaktivierenSuccess') {
          schreibeAktivInCache(cache, false);
        }
      },
    },
  );

  async function setzeAktiv(neuerWert: boolean): Promise<boolean> {
    try {
      if (neuerWert) {
        const { data } = await aktiviere();
        return data?.aktiviereApi.__typename === 'ApiAktivierenSuccess';
      }

      const { data } = await deaktiviere();
      return data?.deaktiviereApi.__typename === 'ApiDeaktivierenSuccess';
    } catch (error) {
      Sentry.captureException(error);
      return false;
    }
  }

  return { setzeAktiv, loading: aktiviereLaeuft || deaktiviereLaeuft };
}
